import { BatchStatus } from "@wingspanhq/wingspan-api-sdk";

const STATUS_LABELS: Record<BatchStatus, string> = {
  [BatchStatus.CREATED]: "Not imported",
  [BatchStatus.PENDING]: "Importing",
  [BatchStatus.PROCESSING]: "Importing",
  [BatchStatus.COMPLETED]: "Imported",
  [BatchStatus.FAILED]: "Import failed"
};

export const selectorImportBatchDisplayStatus = (
  status?: BatchStatus
): string => (status ? STATUS_LABELS[status] : "--");
